import React from 'react'

import styles from "./styles/SectionContainer.module.scss"
import { Container } from 'react-bootstrap'

export default function SectionContainer({ classes = '', children }) {
    return (
        <Container className={`${styles.SectionContainer} ${classes}`}>
            {children}
        </Container>
    )
}
